module.exports = __webpack_public_path__ + "img/only-leftgirl.6575c5ae.svg";